module.exports = __webpack_public_path__ + "img/brand--vivanda.5c285a42.png";